











































































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { PageComponentVue } from '@/base'
import {
  pageStore,
  appStore,
  alertStore,
  modalErrorStore,
  bibliographySearchStore,
  modalBibliographySearchHistoryStore,
  traderStore,
  donorStore,
  systemParameterStore,
  authUserStore,
  bibliographyDetailStore,
  dataStore
} from '@/store'
import CODE_KEY from '@/config/code_key'
import BibliographySearchConditionNavigation from '@/components/templates/collection-index/BibliographySearchConditionNavigation.vue'
import {
  BibliographyFreeWordSearch,
  defaultInputFreeWords,
  InputFreeWords
} from '@/components/organisms/BibliographyFreeWordSearch'
import {
  BibliographyAloneSearch,
  InputAloneSearchItem
} from '@/components/organisms/BibliographyAloneSearch'
import {
  BibliographySearchOption,
  InputSearchOptionItem
} from '@/components/organisms/BibliographySearchOption'
import {
  BibliographyBasicSearchBibliography,
  InputBasicSearchBibliographyItem
} from '@/components/organisms/BibliographyBasicSearchBibliography'
import {
  BibliographyBasicSearchCollection,
  InputBasicSearchCollectionItem
} from '@/components/organisms/BibliographyBasicSearchCollection'
import {
  BibliographyAuthoritySearch,
  defaultInputAuthoritySearchItem,
  InputAuthoritySearchItem
} from '@/components/organisms/BibliographyAuthoritySearch'
import {
  BibliographyContentSearch,
  defaultInputContentSearchItem,
  InputContentSearchItem
} from '@/components/organisms/BibliographyContentSearch'
import {
  Alert,
  AlertMessage,
  BibliographySearchHistory,
  BibliographySearchResultItem,
  defaultSystemCode,
  ErrorMessage,
  SystemParameter
} from '@/api'
import {
  AuthoritySearchType,
  BibliographyClass,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullIdWithMarcNo,
  BibliographySearchType,
  DisplayMethod,
  Prefix,
  SearchTarget,
  SearchType,
  AppKeydown,
  AloneSearchType
} from '@/types'

import {
  BIBLIOGRAPHY_CLOSED,
  DATA_STORE_FETCHED,
  PAGE_LOADING_END,
  PAGE_LOADING_START,
  APP_KEYDOWN
} from '@/config/event'
import { defaultInputSearchOptionItem } from '@/components/organisms/BibliographySearchOption/BibliographySearchOption.vue'
import { defaultInputBasicSearchBibliographyItem } from '@/components/organisms/BibliographyBasicSearchBibliography/BibliographyBasicSearchBibliography.vue'
import { defaultInputBasicSearchCollectionItem } from '@/components/organisms/BibliographyBasicSearchCollection/BibliographyBasicSearchCollection.vue'
import { defaultInputAloneSearchItem } from '@/components/organisms/BibliographyAloneSearch/BibliographyAloneSearch.vue'
import { cloneDeep } from 'lodash'
import { loadingSearchHistory } from '@/pages/bibliographies/index.type'
import { SEARCH_CANCEL_DISPLAY_TIME } from '@/config'
import { ModalBibliographyRegistrationSelection } from '@/components/modals/ModalBibliographyRegistrationSelection'
import ModalInterLibraryLoanCollectionEntryForm from '@/components/modals/ModalInterLibraryLoanCollectionEntryForm/ModalInterLibraryLoanCollectionEntryForm.vue'
import { ModalBibliographyTagDataEditOkItem } from '@/store/ModalBibliographyTagDataEditStore'
import { FirstTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'
import { toHalfWidth } from '@/utils'
import {
  BibliographyFreeWordsSearchAndKey,
  InputBibliographyFreeWordsSearchAndKeyItem,
  defaultInputBibliographyFreeWordsSearchAndKeyItem
} from '@/components/organisms/BibliographyFreeWordsSearchAndKey'

export interface SearchCondition {
  searchType: BibliographySearchType
  searchOption: InputSearchOptionItem
  basic: {
    bibliography: InputBasicSearchBibliographyItem
    collection: InputBasicSearchCollectionItem
  }
  alone: InputAloneSearchItem
  free: {
    freeWords: InputFreeWords
    andKey: InputBibliographyFreeWordsSearchAndKeyItem
  }
  authority: InputAuthoritySearchItem
  content: InputContentSearchItem
}

export const defaultSearchCondition = (): SearchCondition => ({
  searchType: 'basic',
  searchOption: defaultInputSearchOptionItem(),
  basic: {
    bibliography: defaultInputBasicSearchBibliographyItem(),
    collection: defaultInputBasicSearchCollectionItem()
  },
  alone: defaultInputAloneSearchItem(),
  free: {
    freeWords: defaultInputFreeWords(),
    andKey: defaultInputBibliographyFreeWordsSearchAndKeyItem()
  },
  authority: defaultInputAuthoritySearchItem(),
  content: defaultInputContentSearchItem()
})

@Component({
  components: {
    BibliographyFreeWordsSearchAndKey,
    ModalInterLibraryLoanCollectionEntryForm,
    BibliographySearchConditionNavigation,
    BibliographySearchOption,
    BibliographyFreeWordSearch,
    BibliographyBasicSearchBibliography,
    BibliographyBasicSearchCollection,
    BibliographyAloneSearch,
    BibliographyAuthoritySearch,
    BibliographyContentSearch,
    ModalBibliographyRegistrationSelection
  }
})
export default class BibliographySearchConditionPage extends PageComponentVue {
  @Ref()
  modalInterLibraryLoanCollectionEntryForm!: ModalInterLibraryLoanCollectionEntryForm

  @Ref()
  modalBibliographyRegistrationSelection!: ModalBibliographyRegistrationSelection

  @Ref()
  bibliographyBasicSearchBibliography!: BibliographyBasicSearchBibliography

  @Ref()
  bibliographyAloneSearch!: BibliographyAloneSearch

  @Ref()
  bibliographyAuthoritySearch!: BibliographyAuthoritySearch

  @Ref()
  bibliographyContentSearch!: BibliographyContentSearch

  @Ref()
  bibliographyFreeWordSearch!: BibliographyFreeWordSearch

  navigationIsMini: boolean = false

  searchCondition: SearchCondition = defaultSearchCondition()

  controller?: AbortController

  searching: boolean = false

  searchCancelSnackbar: boolean = false

  get isFreeSearch(): boolean {
    return this.existsFreeWords && !this.isTooliSearchTarget
  }

  get defaultDisplayMethod(): DisplayMethod {
    const option: string = this.presetValueSettingOnSearch2.option4

    const displayMethod = Object.values(DisplayMethod).find(item => {
      return option === item
    })

    return displayMethod ?? DisplayMethod.Simple
  }

  get defaultSearchTarget(): SearchTarget {
    const option: string = this.presetValueSettingOnSearch1.option2

    const searchTarget = Object.values(SearchTarget).find(item => {
      return option === item
    })

    return searchTarget ?? SearchTarget.Db
  }

  get defaultSearchMethodSynonym(): boolean {
    return this.presetValueSettingOnSearch2.option3 === '1'
  }

  get defaultSearchMethodAllograph(): boolean {
    return this.presetValueSettingOnSearch2.option2 === '1'
  }

  get defaultAndSearchType(): SearchType[] {
    const option: string = this.presetValueSettingOnSearch1.option1

    const searchType = Object.values(SearchType).find(item => {
      return option === item
    })

    if (searchType) {
      return [searchType]
    }

    return []
  }

  get defaultAndBibliographyClass(): BibliographyClass[] {
    const bibliographyClass = Object.values(BibliographyClass).find(
      value => value === this.presetValueSettingOnSearch1.option3
    )
    return bibliographyClass ? [bibliographyClass] : []
  }

  get resetInputSearchOption(): InputSearchOptionItem {
    const item: InputSearchOptionItem = defaultInputSearchOptionItem()
    item.displayMethod.input = this.defaultDisplayMethod
    item.searchTarget.input = this.defaultSearchTarget
    item.searchMethodSynonym.input = this.defaultSearchMethodSynonym
    item.searchMethodAllograph.input = this.defaultSearchMethodAllograph
    item.andSearchType = this.defaultAndSearchType
    item.andBibliographyClass = this.defaultAndBibliographyClass
    return item
  }

  get existsFreeWords(): boolean {
    return !!this.searchCondition.free.freeWords.input
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isTooliSearchTarget(): boolean {
    return (
      this.searchCondition.searchOption.searchTarget.input ===
      SearchTarget.Tooli
    )
  }

  get search(): any {
    if (this.isFreeSearch) {
      return this.freeSearch
    }

    const regexp = new RegExp(
      `^[0-9]{${
        systemParameterStore.collectionNoMaxDigits
      }}$|^D[0-9]{${systemParameterStore.collectionNoMaxDigits - 1}}$`
    )

    const search: any = {
      basic:
        !this.isTooliSearchTarget &&
        toHalfWidth(this.searchCondition.basic.bibliography.title1.input).match(
          regexp
        )
          ? () => this.aloneSearch(true)
          : this.basicSearch,
      alone: () => this.aloneSearch(false),
      authority: this.authoritySearch,
      content: this.contentSearch
    }

    return search[this.searchCondition.searchType]
  }

  get styleOfLayout(): object {
    return {
      'margin-right': this.navigationIsMini ? '61px' : '200px'
    }
  }

  get navigationStyle(): object {
    return {
      width: this.navigationIsMini ? '61px' : '200px'
    }
  }

  get styleOfTabs(): object {
    if (this.fontSizeType === 'normal') return {}
    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get presetValueSettingOnSearch1(): SystemParameter {
    return systemParameterStore.presetValueSettingOnSearch1
  }

  get presetValueSettingOnSearch2(): SystemParameter {
    return systemParameterStore.presetValueSettingOnSearch2
  }

  get isHitOneSearchResults(): boolean {
    return bibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return bibliographySearchStore.items
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  @Watch('searchCondition.basic.bibliography.title1.input')
  onInputTitle1(newVal: string) {
    const regexp = new RegExp(
      `^[0-9]{${
        systemParameterStore.collectionNoMaxDigits
      }}$|^D[0-9]{${systemParameterStore.collectionNoMaxDigits - 1}}$`
    )

    if (!this.isTooliSearchTarget && toHalfWidth(newVal).match(regexp)) {
      this.aloneSearch(true)
    }
  }

  asyncData() {
    traderStore.fetchAll()
    donorStore.fetchAll()

    systemParameterStore.fetchAllByCodeKeys([
      CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH1.KEY,
      CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH2.KEY,
      CODE_KEY.NUMBER_MANAGEMENT.KEY
    ])
  }

  fetch(): void {
    // 資料の管理：検索を初めて表示する時のみ初期値を設定する
    // 最初の表示のみasyncData含めて二回systemParameter取得処理を行っている。少々冗長だが、表示時間にそこまで影響を与えていないので許容
    // 代案がある場合は優先して修正する予定
    systemParameterStore
      .fetchAllByCodeKeys([
        CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH1.KEY,
        CODE_KEY.PRESET_VALUE_SETTING_ON_SEARCH2.KEY,
        CODE_KEY.NUMBER_MANAGEMENT.KEY
      ])
      .then(() => {
        this.resetSearchConditionBasic()
        this.resetSearchConditionAlone()
        this.resetSearchConditionFreeWords()
        this.searchCondition.searchOption = this.resetInputSearchOption

        // 初期表示だけ制御したいのでこのタイミングで設定する
        this.searchCondition.alone.searchType =
          dataStore.bibliographySearchAloneInitialSelectValue
      })
  }

  created() {
    this.$eventBus.on(DATA_STORE_FETCHED, () =>
      this.$nextTick(this.setRightFooterActions)
    )
  }

  activated(): void {
    pageStore.setTitle('資料の管理：検索')
    pageStore.setLeftFooterActions([
      {
        text: 'トップへ',
        icon: 'arrow-left',
        callback: () => {
          this.$router.push('/')
        }
      }
    ])
    this.setRightFooterActions()
    this.$eventBus.on(APP_KEYDOWN, this.appKeydown)

    this.focus()
  }

  deactivated(): void {
    this.$eventBus.off(DATA_STORE_FETCHED)
    this.$eventBus.off(APP_KEYDOWN)
  }

  setRightFooterActions(): void {
    const actions = [
      {
        text: 'クリア',
        icon: '',
        callback: this.clear
      },
      {
        text: '検索履歴',
        icon: '',
        callback: () => {
          modalBibliographySearchHistoryStore.open({
            onClickExecution: (item: BibliographySearchHistory) => {
              this.searchCondition = loadingSearchHistory(item)
              this.search()
            },
            onClickLoading: (item: BibliographySearchHistory) => {
              this.searchCondition = loadingSearchHistory(item)
            }
          })
        }
      },
      {
        text: '書誌の新規登録',
        icon: '',
        callback: () => {
          this.modalBibliographyRegistrationSelection.open()
        },
        disabled: this.isAuthUserGroupBibliographyOnlyReference
      }
    ]

    if (dataStore.displayBibliographySearchInterLibraryLoanCollectionCreate) {
      actions.push({
        text: '相互貸借の新規登録',
        icon: '',
        callback: () => {
          this.modalInterLibraryLoanCollectionEntryForm.open({
            isNewRegister: true,
            initialBibliography: {
              searchType: SearchType.Book,
              materialFormat: '',
              titleDisplay:
                this.searchCondition.basic.bibliography.title1.input ||
                this.searchCondition.basic.bibliography.title2.input,
              authorDisplay: this.isIncludesKanjiOrHiragana(
                this.searchCondition.basic.bibliography.author1.input ||
                  this.searchCondition.basic.bibliography.author2.input
              )
                ? this.searchCondition.basic.bibliography.author1.input ||
                  this.searchCondition.basic.bibliography.author2.input
                : '',
              authorKana: !this.isIncludesKanjiOrHiragana(
                this.searchCondition.basic.bibliography.author1.input ||
                  this.searchCondition.basic.bibliography.author2.input
              )
                ? this.searchCondition.basic.bibliography.author1.input ||
                  this.searchCondition.basic.bibliography.author2.input
                : '',
              publisherDisplay: this.isIncludesKanjiOrHiragana(
                this.searchCondition.basic.bibliography.publisher.input
              )
                ? this.searchCondition.basic.bibliography.publisher.input
                : '',
              publisherKana: !this.isIncludesKanjiOrHiragana(
                this.searchCondition.basic.bibliography.publisher.input
              )
                ? this.searchCondition.basic.bibliography.publisher.input
                : '',
              isbn: this.searchCondition.alone.isbn.input,
              classNo: this.searchCondition.basic.bibliography.classNo.input
            }
          })
        },
        disabled: this.isAuthUserGroupBibliographyOnlyReference
      })
    }

    pageStore.setRightFooterActions(actions)
  }

  appKeydown(event: AppKeydown): void {
    if (!event.ctrlKey) {
      return
    }

    if (event.key === '1') {
      this.searchCondition.searchType = BibliographySearchType.Basic
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyBasicSearchBibliography.focus()
        })
      })
    } else if (event.key === '2') {
      this.searchCondition.searchType = BibliographySearchType.Basic
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyBasicSearchBibliography.focusAuthor()
        })
      })
    } else if (event.key === '3') {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.bibliographyFreeWordSearch.focus()
        })
      })
    } else if (event.key === '4') {
      this.searchCondition.searchType = BibliographySearchType.Alone
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.searchCondition.alone.searchType = AloneSearchType.Isbn
          this.$nextTick(() => {
            this.bibliographyAloneSearch.focusIsbn()
          })
        })
      })
    } else if (event.key === '5') {
      this.searchCondition.searchType = BibliographySearchType.Alone
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.searchCondition.alone.searchType = AloneSearchType.Marc
          this.$nextTick(() => {
            this.bibliographyAloneSearch.focusMarcNo()
          })
        })
      })
    }
  }

  isIncludesKanjiOrHiragana(value: string): boolean {
    return value.match(/[ぁ-ん一-龠々]/g) !== null
  }

  saveSearchCondition() {
    bibliographySearchStore.setSearchCondition(cloneDeep(this.searchCondition))
  }

  startSearchCanceler() {
    this.controller = new AbortController()
    setTimeout(() => {
      if (this.searching) {
        this.searchCancelSnackbar = true
      }
    }, SEARCH_CANCEL_DISPLAY_TIME)
  }

  stopSearchCanceler() {
    this.controller = undefined
    this.searchCancelSnackbar = false
  }

  onChangeTab(searchType: BibliographySearchType): void {
    this.searchCondition.searchType = searchType
    this.focus()
  }

  resetSearchConditionBasic(): void {
    const bibliographyItem: InputBasicSearchBibliographyItem = defaultInputBasicSearchBibliographyItem()
    const collectionItem: InputBasicSearchCollectionItem = defaultInputBasicSearchCollectionItem()

    bibliographyItem.titleInformation =
      systemParameterStore.defaultCollectionSearchTitleInformationValue
    collectionItem.holdingBranchCodes.input = systemParameterStore.presetValueSettingOnSearch1.option4.replace(
      /(\d)(?=(\d\d)+(?!\d))/g,
      '$1,'
    )
    collectionItem.collectionStatus.collectionStatusRemove =
      systemParameterStore.defaultCollectionStatusRemove

    this.searchCondition.basic.bibliography = bibliographyItem
    this.searchCondition.basic.collection = collectionItem
  }

  resetSearchConditionAlone(): void {
    const item: InputAloneSearchItem = defaultInputAloneSearchItem()

    item.marcType.input =
      systemParameterStore.presetValueSettingOnSearch1.option5

    this.searchCondition.alone = item
  }

  resetSearchConditionFreeWords(): void {
    const andKeyItem: InputBibliographyFreeWordsSearchAndKeyItem = defaultInputBibliographyFreeWordsSearchAndKeyItem()

    andKeyItem.holdingBranchCodes.input = systemParameterStore.presetValueSettingOnSearch1.option4.replace(
      /(\d)(?=(\d\d)+(?!\d))/g,
      '$1,'
    )
    andKeyItem.collectionStatus.collectionStatusRemove =
      systemParameterStore.defaultCollectionStatusRemove

    this.searchCondition.free.freeWords = defaultInputFreeWords()
    this.searchCondition.free.andKey = andKeyItem
  }

  focus(): void {
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        switch (this.searchCondition.searchType) {
          case 'basic':
            this.bibliographyBasicSearchBibliography.focus()
            break
          case 'alone':
            this.bibliographyAloneSearch.focus()
            break
          case 'authority':
            this.bibliographyAuthoritySearch.focus()
            break
          case 'content':
            this.bibliographyContentSearch.focus()
            break
        }
      })
    })
  }

  async basicSearch() {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      bibliographySearchStore.reset()
      bibliographyDetailStore.reset()
      if (this.isTooliSearchTarget) {
        await bibliographySearchStore.basicSearchTooli(this.controller?.signal)
      } else {
        await bibliographySearchStore.basicSearch(this.controller?.signal)
      }
      if (this.isHitOneSearchResults) {
        this.goSearchBibliographyDetailPageForOneHit({
          prefix: this.searchResults[0].prefix,
          id: this.searchResults[0].bibliographyId,
          marcNo: this.searchResults[0].marcNo,
          title: this.searchResults[0].displayTitle
        })
      } else {
        this.goSearchResultPage()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfBasicSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async aloneSearch(isInputBasicSearch: boolean) {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      bibliographySearchStore.reset()
      bibliographyDetailStore.reset()
      if (this.isTooliSearchTarget) {
        await bibliographySearchStore.aloneSearchTooli(this.controller?.signal)
      } else {
        await bibliographySearchStore.aloneSearch(
          isInputBasicSearch,
          this.controller?.signal
        )
      }
      if (this.isHitOneSearchResults) {
        this.goSearchBibliographyDetailPageForOneHit({
          prefix: this.searchResults[0].prefix,
          id: this.searchResults[0].bibliographyId,
          marcNo: this.searchResults[0].marcNo,
          title: this.searchResults[0].displayTitle
        })
      } else {
        this.goSearchResultPage()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfAloneSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async authoritySearch() {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()
    bibliographySearchStore.setAuthoritySearchType(
      this.searchCondition.authority.searchType
    )

    this.searching = true
    this.startSearchCanceler()

    try {
      bibliographySearchStore.reset()
      bibliographyDetailStore.reset()
      await bibliographySearchStore.authoritySearch(this.controller?.signal)
      if (bibliographySearchStore.authorityItems.length === 1) {
        if (
          this.searchCondition.authority.searchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          await this.authorityIdContentSearch()
        } else {
          await this.authorityIdSearch()
        }
      } else {
        this.goSearchResultAuthorityPage()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfAuthoritySearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 典拠検索結果のbibliographyCountが合計1のみだった場合
  async authorityIdSearch() {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const nos: string[] = [
        bibliographySearchStore.authorityItems[0].authorityNo
      ]
      switch (bibliographySearchStore.authoritySearchType) {
        case AuthoritySearchType.Author:
          bibliographySearchStore.setAuthorIds(nos)
          break
        case AuthoritySearchType.ContentAuthor:
          bibliographySearchStore.setContentAuthorIds(nos)
          break
        case AuthoritySearchType.Subject:
          bibliographySearchStore.setSubjectIds(nos)
          break
        case AuthoritySearchType.CompleteWorks:
          bibliographySearchStore.setCompleteWorksIds(nos)
          break
        case AuthoritySearchType.Series:
          bibliographySearchStore.setSeriesIds(nos)
          break
        case AuthoritySearchType.Publisher:
          bibliographySearchStore.setPublisherIds(nos)
          break
      }

      await bibliographySearchStore.authorityIdSearch()

      if (bibliographySearchStore.total === 1) {
        this.goSearchBibliographyDetailPageForOneHit({
          prefix: this.searchResults[0].prefix,
          id: this.searchResults[0].bibliographyId,
          marcNo: this.searchResults[0].marcNo,
          title: this.searchResults[0].displayTitle
        })
      } else {
        this.goSearchResultPage()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async authorityIdContentSearch() {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)

    const nos = [bibliographySearchStore.authorityItems[0].authorityNo]

    try {
      bibliographySearchStore.resetPage()
      bibliographySearchStore.setContentAuthorIds(nos)

      await bibliographySearchStore.authorityIdContentSearch()

      if (bibliographySearchStore.contentItems.length === 1) {
        const item = bibliographySearchStore.contentItems[0]

        await this.$router.push({
          path: '/bibliographies/detail-real',
          query: {
            id: String(item.bibliographyId),
            prefix: item.prefix,
            title: item.displayTitle,
            page: '1' // 検索結果が1件である以上、ページは必ず1となる
          },
          hash: `#${BibliographyDetailRealTabType.Content}`
        })
      } else {
        await this.$router.push('/bibliographies/search-result-content')
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async contentSearch() {
    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      bibliographySearchStore.reset()
      bibliographyDetailStore.reset()
      if (this.isTooliSearchTarget) {
        await bibliographySearchStore.contentSearchTooli(
          this.controller?.signal
        )
        if (this.isHitOneSearchResults) {
          this.goSearchBibliographyDetailPageForOneHit({
            prefix: this.searchResults[0].prefix,
            id: this.searchResults[0].bibliographyId,
            marcNo: this.searchResults[0].marcNo,
            title: this.searchResults[0].displayTitle
          })
        } else {
          this.goSearchResultPage()
        }
      } else {
        await bibliographySearchStore.contentSearch(this.controller?.signal)
        if (bibliographySearchStore.contentItems.length === 1) {
          this.goSearchBibliographyDetailPageForOneHit({
            prefix: bibliographySearchStore.contentItems[0].prefix,
            id: bibliographySearchStore.contentItems[0].bibliographyId,
            marcNo: '',
            title: bibliographySearchStore.contentItems[0].displayTitle
          })
        } else {
          this.goSearchResultContentPage()
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfContentSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async freeSearch() {
    this.searching = true

    this.$eventBus.emit(BIBLIOGRAPHY_CLOSED)
    this.$eventBus.emit(PAGE_LOADING_START)
    this.saveSearchCondition()

    this.searching = true
    this.startSearchCanceler()

    try {
      bibliographySearchStore.reset()
      bibliographyDetailStore.reset()
      await bibliographySearchStore.freeSearch(this.controller?.signal)
      if (this.isHitOneSearchResults) {
        this.goSearchBibliographyDetailPageForOneHit({
          prefix: this.searchResults[0].prefix,
          id: this.searchResults[0].bibliographyId,
          marcNo: this.searchResults[0].marcNo,
          title: this.searchResults[0].displayTitle
        })
      } else {
        this.goSearchResultPage()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessageOfFreeSearch(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.stopSearchCanceler()
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  clear(): void {
    if (this.searchCondition.free.freeWords.input !== '') {
      this.resetSearchConditionFreeWords()
      this.searchCondition.searchOption = defaultInputSearchOptionItem()
    }

    switch (this.searchCondition.searchType) {
      case 'basic':
        this.resetSearchConditionBasic()
        this.searchCondition.searchOption = defaultInputSearchOptionItem()
        break
      case 'alone':
        this.searchCondition.alone = defaultInputAloneSearchItem()
        this.resetSearchConditionAlone()
        this.searchCondition.searchOption.displayMethod = defaultInputSearchOptionItem().displayMethod
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        break
      case 'authority':
        this.searchCondition.authority = defaultInputAuthoritySearchItem()
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        break
      case 'content':
        this.searchCondition.content = defaultInputContentSearchItem()
        this.searchCondition.searchOption.displayMethod = defaultInputSearchOptionItem().displayMethod
        this.searchCondition.searchOption.searchTarget = defaultInputSearchOptionItem().searchTarget
        this.searchCondition.searchOption.numberOfLimit = defaultInputSearchOptionItem().numberOfLimit
        this.searchCondition.searchOption.searchMethodAnd = defaultInputSearchOptionItem().searchMethodAnd
        this.searchCondition.searchOption.searchMethodSynonym = defaultInputSearchOptionItem().searchMethodSynonym
        this.searchCondition.searchOption.searchMethodAllograph = defaultInputSearchOptionItem().searchMethodAllograph
        this.searchCondition.searchOption.andSearchType = defaultInputSearchOptionItem().andSearchType
        this.searchCondition.searchOption.andCollectionTarget = defaultInputSearchOptionItem().andCollectionTarget
    }

    this.focus()
  }

  onClickSearchCancel() {
    this.searchCancelSnackbar = false
    if (this.controller) {
      this.controller.abort()
    }
  }

  convertCamelCaseFromSnakeCase(value: string): string {
    return value.replace(/_./g, str => str.charAt(1).toUpperCase())
  }

  goSearchResultPage(): void {
    this.$router.push('/bibliographies/search-result')
  }

  goSearchResultAuthorityPage(): void {
    this.$router.push('/bibliographies/search-result-authority')
  }

  goSearchResultContentPage() {
    this.$router.push('/bibliographies/search-result-content')
  }

  // 取得件数1件の時のみ使用
  goSearchBibliographyDetailPageForOneHit(
    value: BibliographyFullIdWithMarcNo
  ): void {
    bibliographyDetailStore.setFirstTransitionSource(
      FirstTransitionToBibliographyDetail.Search
    )
    bibliographyDetailStore.setFirstBibliographyInfo({
      prefix: value.prefix,
      id: value.id,
      marcNo: value.marcNo,
      title: value.title
    })

    let hash: string = ''

    if (this.isTooliSearchTarget) {
      hash = BibliographyDetailRealTabType.Tooli
    } else if (value.prefix === Prefix.Real) {
      if (bibliographySearchStore.contentItems.length > 0) {
        hash = BibliographyDetailRealTabType.Content
      } else {
        hash = BibliographyDetailRealTabType.Collection
      }
    } else {
      hash = BibliographyDetailSetTabType.Volume
    }

    this.$router.push({
      path: `/bibliographies/detail-${
        value.prefix === Prefix.Real ? 'real' : 'set'
      }`,
      query: {
        marc_no: this.isTooliSearchTarget ? value.marcNo : undefined,
        id: !this.isTooliSearchTarget ? String(value.id) : undefined,
        prefix: !this.isTooliSearchTarget ? value.prefix : undefined,
        title: value.title,
        page: '1' // 検索結果が1件である以上、ページは必ず1となる
      },
      hash: `#${hash}`
    })
  }

  onChangeNavigation() {
    this.navigationIsMini = !this.navigationIsMini
  }

  setErrorMessageOfContentSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.content
      if (
        [
          'display_method',
          'search_target',
          'number_of_limit',
          'search_method_and',
          'search_method_synonym',
          'search_method_allograph',
          'and_search_type',
          'and_collection_target'
        ].includes(alert.attribute)
      ) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      ).replace(/(Not$)|(Id$)/g, '')

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfAuthoritySearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.authority
      if (
        [
          'display_method',
          'search_target',
          'number_of_limit',
          'search_method_and',
          'search_method_synonym',
          'search_method_allograph',
          'and_search_type',
          'and_collection_target',
          'and_bibliography_class'
        ].includes(alert.attribute)
      ) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      ).replace(/Id$/g, '')

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfAloneSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      let setTargetItem: any = this.searchCondition.alone
      if (
        ['display_method', 'search_target', 'number_of_limit'].includes(
          alert.attribute
        )
      ) {
        setTargetItem = this.searchCondition.searchOption
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      )

      if (setTargetItem[convertedPropertyName]) {
        setTargetItem[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfBasicSearch(alerts: Alert[]) {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      // eslint-disable-next-line prefer-const
      let [target1, target2] = alert.attribute.split('.')
      let setTargetObject: any = this.searchCondition.searchOption
      switch (target1) {
        case 'bibliography':
          setTargetObject = this.searchCondition.basic.bibliography
          target1 = target2
          break
        case 'collection':
          setTargetObject = this.searchCondition.basic.collection
          target1 = target2
          break
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        target1
      ).replace(/(Not$)|(Id$)|(Flag$)/g, '')

      if (setTargetObject[convertedPropertyName]) {
        setTargetObject[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  setErrorMessageOfFreeSearch(alerts: Alert[]): void {
    alerts.some(alert => {
      if (alert.attribute === '') return false

      // eslint-disable-next-line prefer-const
      let [target1, target2] = alert.attribute.split('.')
      let setTargetObject: any = this.searchCondition.searchOption
      switch (target1) {
        case 'free_words':
          this.searchCondition.free.freeWords.errorMessage = alert.message
          return false
        case 'bibliography':
          setTargetObject = this.searchCondition.free.andKey
          target1 = target2
          break
        case 'collection':
          setTargetObject = this.searchCondition.free.andKey
          target1 = target2
          break
      }

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        target1
      ).replace(/(Not$)|(Id$)|(Flag$)/g, '')

      if (setTargetObject[convertedPropertyName]) {
        setTargetObject[convertedPropertyName].errorMessage = alert.message
      }
    })
  }

  onClickBookRegistration() {
    this.$modalBibliographyTagDataEdit.open({
      bibliographyClass: BibliographyClass.Real,
      searchType: { ...defaultSystemCode(), code: SearchType.Book },
      onOk: (item: ModalBibliographyTagDataEditOkItem) => {
        bibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.SearchCreate
        )

        this.$router.push({
          path: '/bibliographies/detail-real',
          query: {
            id: String(item.bibliographyId),
            prefix: Prefix.Real,
            title: item.title
          }
        })
      }
    })
  }

  onClickAvRegistration() {
    this.$modalBibliographyTagDataEdit.open({
      bibliographyClass: BibliographyClass.Real,
      searchType: { ...defaultSystemCode(), code: SearchType.Av },
      onOk: (item: ModalBibliographyTagDataEditOkItem) => {
        bibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.SearchCreate
        )

        this.$router.push({
          path: '/bibliographies/detail-real',
          query: {
            id: String(item.bibliographyId),
            prefix: Prefix.Real,
            title: item.title
          }
        })
      }
    })
  }

  onClickMagazineRegistration() {
    this.$modalBibliographyTagDataEdit.open({
      bibliographyClass: BibliographyClass.Set,
      searchType: { ...defaultSystemCode(), code: SearchType.Magazine },
      onOk: (item: ModalBibliographyTagDataEditOkItem) => {
        bibliographyDetailStore.setFirstTransitionSource(
          FirstTransitionToBibliographyDetail.SearchCreate
        )

        this.$router.push({
          path: '/bibliographies/detail-set',
          query: {
            id: String(item.bibliographyId),
            prefix: Prefix.Set,
            title: item.title
          }
        })
      }
    })
  }
}
